import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';
import { sortByDate } from 'utils';

export const manageCreativeMediaAPI = createApi({
  reducerPath: 'CreativeImagesAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/Creative' }),
  tagTypes: [
    'Creative/GetCreativeIcons',
    'Creative/GetCreativeImagesByType',
    'Creative/GetCreativeImages',
    'Creative/GetCreativeVideos',
  ],
  endpoints: (build) => ({
    getCreativeImages: build.query({
      query: (reqObj) => ({
        url: `/GetCreativeImages?pba_id=${reqObj.pba_id}&package_id=${reqObj.package_id}`,
      }),
      providesTags: ['Creative/GetCreativeImages'],
      transformResponse: (response) => sortByDate(response),
    }),
    GetCreativeimageTypes: build.query({
      query: () => ({
        url: `/GetCreativeimageTypes`,
      }),
    }),
    getCreativeIcons: build.query({
      query: (reqObj) => ({
        url: `/GetCreativeIcons?pba_id=${reqObj.pba_id}&package_id=${reqObj.package_id}`,
      }),
      providesTags: ['Creative/GetCreativeIcons'],
      transformResponse: (response) => sortByDate(response),
    }),
    getCreativeVideos: build.query({
      query: (reqObj) => ({
        url: `/GetCreativeVideos?pba_id=${reqObj.pba_id}&package_id=${reqObj.package_id}&video_type=${reqObj.videoType}`,
      }),
      providesTags: ['Creative/GetCreativeVideos'],
      transformResponse: (response) => sortByDate(response),
    }),
    uploadCreativeVideo: build.mutation({
      query: (requestBody) => ({
        url: `/UploadVideo`,
        method: 'POST',
        data: requestBody,
      }),
      invalidatesTags: ['Creative/GetCreativeVideos'],
    }),
    removeCreativeImage: build.mutation({
      query: (imageId) => {
        let image_id;
        if (typeof imageId === 'string') {
          image_id = imageId;
        } else {
          image_id = imageId.media_id;
        }

        return {
          url: `/RemoveCreativeImage?imageId=${image_id}`,
          method: 'POST',
        };
      },
      invalidatesTags: (result, error, fetchData) => {
        return [
          { type: 'Creative/GetCreativeIcons' },
          { type: 'Creative/GetCreativeImages' },
          {
            type: 'Creative/GetCreativeImagesByType',
            id: `${fetchData.package_id}_${fetchData.image_type}`,
          },
        ];
      },
      //invalidatesTags: ['Creative/GetCreativeIcons', 'Creative/GetCreativeImages'],
    }),
    removeCreativeVideo: build.mutation({
      query: (vidoeId) => ({
        url: `/RemoveCreativeVideo?vidoeId=${vidoeId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Creative/GetCreativeVideos'],
    }),
    GetCreativeImagesByType: build.query({
      query: ({ package_id, image_type, pba_id }) => ({
        //url: `/GetCreativeImagesByType?package_id=${fetchData.package_id}&type=${fetchData.image_type}&pba_id=${fetchData.pba_id}`,
        url: '/GetCreativeImagesByType',
        params: {
          package_id,
          type: image_type,
          pba_id,
        },
      }),
      providesTags: (result, error, fetchData) => {
        return [
          {
            type: 'Creative/GetCreativeImagesByType',
            id: `${fetchData.package_id}_${fetchData.image_type}`,
          },
        ];
      },
    }),
    UploadCreativeImageData: build.mutation({
      query: (requestBody) => ({
        url: `/UploadCreativeImageData`,
        method: 'POST',
        data: {
          imageType: requestBody.imageType,
          pba_id: requestBody.pba_id,
          package_id: requestBody.package_id,
          file: requestBody.file,
        },
      }),
      invalidatesTags: (result, error, fetchData) => {
        return [
          {
            type: 'Creative/GetCreativeImagesByType',
            id: `${fetchData.package_id}_${fetchData.imageType}`,
          },
        ];
      },
    }),
    uploadMediaToServer: build.mutation({
      query: (requestBody) => ({
        url: `/UploadImageData`,
        method: 'POST',
        data: {
          imageType: requestBody.imageType,
          pba_id: requestBody.pba_id,
          package_id: requestBody.package_id,
          file: requestBody.file,
        },
      }),
      invalidatesTags: ['Creative/GetCreativeIcons', 'Creative/GetCreativeImages'],
    }),
  }),
});
